import { MessageCircle } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { whatsappLink } from "../i18n/translations";
import { Reveal, Eyebrow } from "./Reveal";

export const Contact = () => {
  const { t } = useLanguage();

  return (
    <section id="contact" data-testid="contact-section" className="relative py-32 sm:py-44 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: "url(/images/hero.png)" }}
      />
      <div className="absolute inset-0 bg-black/82" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(197,160,89,0.12),transparent_60%)]" />

      <div className="relative max-w-3xl mx-auto px-5 sm:px-8 text-center">
        <Reveal>
          <Eyebrow>{t.contact_eyebrow}</Eyebrow>
          <h2 className="font-serif text-3xl sm:text-5xl lg:text-6xl text-[#F7F3E9] leading-tight">
            {t.contact_title}
          </h2>
          <p className="mt-7 text-[#C7BFA7] font-light leading-relaxed text-base sm:text-lg">{t.contact_text}</p>
        </Reveal>

        <Reveal delay={0.15}>
          <a
            data-testid="contact-whatsapp-cta"
            href={whatsappLink(t.whatsapp_message)}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-12 inline-flex items-center gap-3 px-10 py-5 bg-[#C5A059] text-black text-sm font-semibold tracking-[0.16em] uppercase hover:bg-[#EED8A1] transition-colors duration-300 pulse-gold"
          >
            <MessageCircle size={19} />
            <span>{t.contact_cta}</span>
          </a>
          <p data-testid="contact-phone-note" className="mt-6 text-xs tracking-[0.24em] uppercase text-[#8A8270]">
            {t.contact_note}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
